export const initValues = {
  name: "",
  surname: "",
  department: null,
  company: null,
  user: null,
  supervisor: null,
  additionalDepartments: [],
}
